import { onSubmitMultiplier } from 'utils';
import { MultiplierUpdateOnSubmitFunction } from './updateMultiplier.type';

const multiplierUpdateOnSubmit: MultiplierUpdateOnSubmitFunction = payload => {
  console.error(payload)
  return onSubmitMultiplier({ method: 'put', ...payload, id: payload.multiplier.id });
};

export default multiplierUpdateOnSubmit;